import { render } from "./Terms-of-service-page.vue?vue&type=template&id=4ebeb4c8"
import script from "./Terms-of-service-page.vue?vue&type=script&lang=js"
export * from "./Terms-of-service-page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__